module.exports = __webpack_public_path__ + "img/page3-1.b5f160fc.png";